export default {
  // Page titles
  title: 'ห้อง',
  unit_detail: 'รายละเอียดห้อง',
  edit_unit: 'แก้ไขห้อง',
  form: {
    title_new: 'เพิ่มห้อง',
  },

  // EP-54: Thai has no plural inflection; single base key. i18next v25 falls
  // back to the base key when _one/_other variants are absent for a locale.
  units_count: '{{count}} ห้อง',
  vacant_count: '{{count}} ว่าง',

  // Descriptions
  description: 'จัดการห้องเช่า',
  edit_description: 'แก้ไขรายละเอียดห้อง',

  // Labels
  labels: {
    unit_name: 'ชื่อห้อง',
    unit_number: 'หมายเลขห้อง',
    monthly_rent: 'ค่าเช่ารายเดือน',
    monthly_rent_thb: 'ค่าเช่ารายเดือน (฿)',
    room_type: 'ประเภทห้อง',
    room_type_move_hint: 'ย้ายห้องนี้ไปยังประเภทห้องอื่นภายในอสังหาริมทรัพย์เดียวกัน',
    property: 'อสังหาริมทรัพย์',
    status: 'สถานะ',
    occupancy: 'การเข้าพัก',
    current_tenant: 'ผู้เช่าปัจจุบัน',
    meters: 'มิเตอร์',
    units: 'ห้อง',
    override_rates: 'กำหนดอัตราค่าบริการเฉพาะห้องนี้',
    uses_property_default: 'ใช้อัตราค่าบริการตามอสังหาริมทรัพย์',
    custom_rates: 'อัตราค่าบริการเฉพาะห้อง',
    utility_rates_override: 'กำหนดอัตราค่าสาธารณูปโภคเฉพาะห้อง',
    property_default: 'อัตราตามอสังหาริมทรัพย์',
    area_sqm: 'พื้นที่ (ตร.ม.)',
    share_ratio: 'สัดส่วนพื้นที่',
    condominium_fields: 'ข้อมูลคอนโดมิเนียม',
    condominium_fields_description: 'จำเป็นสำหรับการคำนวณค่าส่วนกลาง (วิธีคำนวณต่อตร.ม. หรือสัดส่วนพื้นที่)',
  },

  // Placeholders
  placeholders: {
    unit_name: 'เช่น 101, A1',
    monthly_rent: '5000',
    price_example: '5000',
  },

  // Status
  status: {
    vacant: 'ว่าง',
    occupied: 'มีผู้เช่า',
    // EP-136 T136-020 — a unit HELD by a paid/billed booking fee (draft
    // RentalLease + current_booking), distinct from both vacant and occupied.
    reserved: 'จองแล้ว',
  },

  // Room type section
  room_type: {
    title: 'ประเภทห้อง',
    detail: 'รายละเอียดประเภทห้อง',
    edit: 'แก้ไขประเภทห้อง',
    edit_description: 'แก้ไขรายละเอียดประเภทห้อง',
    name: 'ชื่อ',
    name_placeholder: 'เช่น สตูดิโอ, 1 ห้องนอน',
    floor: 'ชั้น',
    floor_placeholder: 'เช่น 1, G, B1',
    not_found: 'ไม่พบประเภทห้อง',
  },

  // Actions
  actions: {
    add_unit: 'เพิ่มห้อง',
    add_meter: 'เพิ่มมิเตอร์',
    add_meter_to_unit: 'เพิ่มมิเตอร์ให้ห้อง {{name}}',
    view_lease: 'ดูสัญญาเช่า',
    meter: 'มิเตอร์',
    // EP-134 §7 (T134-007) — Transfer Ownership lives on the unit-detail
    // page's overflow menu (admin+ only; gated on `condominium_enabled`).
    transfer_ownership: 'โอนกรรมสิทธิ์',
    // EP-136 T136-022 — gated on `unit.bookable === true`, never on
    // `unit.status === 'vacant'` (see UnitDetailPage.tsx).
    book: 'จอง',
  },

  // EP-136 T136-022/T136-023 — Book action, the Book modal form, and the
  // reservation card.
  booking: {
    modal_title: 'จองห้อง',
    card_title: 'การจอง',
    reserved_by: 'จองโดย',
    no_customer: 'ไม่มีข้อมูลลูกค้า',
    expires_at: 'วันหมดอายุการจอง',
    days_left: 'เหลืออีก {{count}} วัน',
    invoice: 'ใบแจ้งหนี้ค่าจอง',
    invoice_paid: 'ชำระแล้ว',
    invoice_unpaid: 'ยังไม่ชำระ',
    view_draft_lease: 'ดูสัญญาเช่าฉบับร่าง',

    // T136-023 — the Book modal form fields. The booking MODE is resolved
    // server-side and shown read-only here (never a form control) — see
    // BookingModal.tsx's file banner.
    form: {
      customer_label: 'ลูกค้า',
      customer_placeholder: 'ค้นหาลูกค้า…',
      started_at_label: 'วันที่เริ่มต้น',
      started_at_hint: 'วันที่ผู้เช่าคาดว่าจะย้ายเข้า สำหรับสัญญาเช่าฉบับร่างที่การจองนี้จะสร้างขึ้น',
      mode_label: 'รูปแบบค่าจอง',
      mode_hint: 'กำหนดที่อสังหาริมทรัพย์ ไม่ใช่ที่นี่',
      mode_hint_link: 'จัดการในการตั้งค่าการจอง',
      amount_label: 'จำนวนเงินค่าจอง',
      reservation_expires_at_label: 'วันหมดอายุการจอง',
      reservation_expires_at_hint: 'ห้องจะถูกจองไว้จนถึงวันนี้ ค่าเริ่มต้นคือวันสุดท้ายของเดือนปัจจุบัน',
    },

    messages: {
      create_success: 'จองห้องสำเร็จ',
    },
  },

  // Empty states
  empty: {
    no_units: 'ไม่มีห้อง',
    no_units_description: 'เพิ่มห้องในประเภทห้องนี้',
    not_found: 'ไม่พบห้อง',
  },

  // Setup guide (room type detail - units section)
  setup_guide: {
    title: 'เพิ่มห้องในประเภทนี้',
    description:
      'ห้องคือห้องแต่ละห้องที่ผู้เช่าสามารถเช่าได้ เพิ่มห้องพร้อมชื่อและค่าเช่ารายเดือน',
    step_1_title: 'สร้างห้อง',
    step_1_description: 'ตั้งชื่อห้อง (เช่น 101, A1) และกำหนดค่าเช่ารายเดือน',
    step_2_title: 'เพิ่มมิเตอร์',
    step_2_description: 'ตั้งค่ามิเตอร์น้ำและไฟฟ้าสำหรับแต่ละห้องเพื่อติดตามการใช้งาน',
    import: 'นำเข้าจากไฟล์',
    import_off_scope_warning: 'พบ {{count}} แถว {{entity}} นำเข้าจากหน้า {{Entity}}',
    download_sample: 'ดาวน์โหลดตัวอย่าง',
    seed_sample: 'เพิ่มข้อมูลตัวอย่าง',
    seed_sample_confirm: 'ระบบจะสร้าง: ห้องตัวอย่าง 1 ห้องในอสังหาริมทรัพย์นี้ ต้องการดำเนินการต่อหรือไม่?',
    seed_sample_success: 'สร้างห้องตัวอย่างสำเร็จ',
    seed_sample_noop: 'มีห้องอยู่แล้ว ไม่ได้เพิ่มข้อมูลตัวอย่าง',
  },

  // Messages
  messages: {
    delete_confirm: 'ลบห้อง "{{name}}"?',
    delete_room_type_confirm: 'ลบ "{{name}}"? จะลบห้องทั้งหมดด้วย',
    delete_unit_cannot_undo: 'ลบห้อง "{{name}}"? การกระทำนี้ไม่สามารถยกเลิกได้',
    delete_blocked_occupied: 'ไม่สามารถลบห้องที่มีผู้เช่าได้',
    created: 'สร้างห้องสำเร็จ',
    updated: 'แก้ไขห้องสำเร็จ',
    deleted: 'ลบห้องสำเร็จ',
  },

  // Validation
  validation: {
    unit_name_required: 'กรุณากรอกชื่อห้อง',
    price_required: 'กรุณากรอกราคา',
    name_required: 'กรุณากรอกชื่อ',
    must_be_positive: 'ต้องเป็นตัวเลขบวก',
  },

  errors: {
    validation_failed: 'ข้อมูลไม่ถูกต้อง กรุณาตรวจสอบแบบฟอร์มอีกครั้ง',

    // T136-023 — the 6 typed 422 codes UnitBookingService raises
    // (api/app/services/unit_booking_service.rb), translated via
    // useApiErrorTranslator('units') in BookingModal.
    booking_not_available_for_condominium_account: 'ไม่สามารถจองห้องได้สำหรับบัญชีคอนโดมิเนียม',
    unit_occupied: 'ห้องนี้มีผู้เช่าอยู่แล้วหรือมีสัญญาที่กำลังดำเนินการ',
    unit_already_reserved: 'ห้องนี้ถูกจองไปแล้ว',
    amount_required: 'กรุณากรอกจำนวนเงินค่าจอง',
    amount_invalid: 'จำนวนเงินค่าจองต้องมากกว่าศูนย์',
    amount_exceeds_deposit: 'จำนวนเงินค่าจองต้องไม่เกินเงินประกันของสัญญาเช่า',

    fields: {
      name: 'ชื่อ',
      floor: 'ชั้น',
      room_type_id: 'ประเภทห้อง',
      monthly_price: 'ราคารายเดือน',
      deposit_amount: 'เงินประกัน',
    },

    codes: {
      blank: 'ต้องไม่เว้นว่าง',
      taken: 'ถูกใช้แล้ว',
      invalid: 'ไม่ถูกต้อง',
      too_short: 'สั้นเกินไป',
      too_long: 'ยาวเกินไป',
      greater_than: 'ต้องมากกว่าค่าที่กำหนด',
      greater_than_or_equal_to: 'ต้องมากกว่าหรือเท่ากับค่าที่กำหนด',
      less_than: 'ต้องน้อยกว่าค่าที่กำหนด',
      less_than_or_equal_to: 'ต้องน้อยกว่าหรือเท่ากับค่าที่กำหนด',
      not_a_number: 'ต้องเป็นตัวเลข',
      inclusion: 'ค่าไม่อยู่ในรายการที่อนุญาต',
    },
  },
}
